type AgeGroupUi = {
  color: string;
  icon: string;
  subtitleKey: string;
};

type CategoryUi = {
  icon: string;
};

export const ageGroupUiMap: Record<string, AgeGroupUi> = {
  age0_6: { color: "#E8927C", icon: "ri-emotion-happy-line", subtitleKey: "age0_6Subtitle" },
  age7_12: { color: "#F4A261", icon: "ri-parent-line", subtitleKey: "age7_12Subtitle" },
  age1_2: { color: "#E9C46A", icon: "ri-walk-line", subtitleKey: "age1_2Subtitle" },
  age2_3: { color: "#2A9D8F", icon: "ri-run-line", subtitleKey: "age2_3Subtitle" },
  age3_4: { color: "#264653", icon: "ri-palette-line", subtitleKey: "age3_4Subtitle" },
  age4_5: { color: "#8AB17D", icon: "ri-brain-line", subtitleKey: "age4_5Subtitle" },
  age5_6: { color: "#6B5B95", icon: "ri-graduation-cap-line", subtitleKey: "age5_6Subtitle" },
};

export const categoryUiMap: Record<string, CategoryUi> = {
  physical: { icon: "ri-body-scan-line" },
  cognitive: { icon: "ri-lightbulb-line" },
  social: { icon: "ri-heart-3-line" },
};

export const getAgeGroupUi = (key: string) => {
  return ageGroupUiMap[key] || { color: "#E9C46A", icon: "ri-star-line", subtitleKey: "" };
};

export const getCategoryUi = (key: string) => {
  return categoryUiMap[key] || { icon: "ri-shape-line" };
};

export const getAgeRangeLabel = (minMonths: number, maxMonths: number) => {
  if (maxMonths <= 12) {
    return `${minMonths} - ${maxMonths}`;
  }

  const minYears = Math.floor(minMonths / 12);
  const maxYears = Math.floor(maxMonths / 12);
  return `${minYears} - ${maxYears}`;
};
